import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ZodiacImageWithName } from '../../utils/static-data';
import TopHeaderSection from '../../components/common/TopHeaderSection';

const Horoscope = () => {
    const navigate = useNavigate();

    console.log(ZodiacImageWithName); // Log the data to verify it's correct

    return (
        <>
            <TopHeaderSection title={'Horoscope'} />

            <section className='px-5 py-5'>
                <article>
                    <div className='text-center'>
                        Confused about how your day would turn out to be? Find out if today is the day to make big decisions. Read your Daily Horoscope forecast and get insights regarding different aspects of your life to plan your day better.
                    </div>

                    <main className='py-[50px] flex flex-wrap items-center lg:gap-x-[1.2%] max-lg:gap-x-[4%] max-md:gap-x-[5%] gap-y-5'>
                        {ZodiacImageWithName?.map((value, index) => (
                            <div
                                onClick={() => navigate(value?.zodiacSign, { state: { zodiacImage: value?.image } })}
                                key={index}
                                className='lg:basis-[19%] max-lg:basis-[22%] max-md:basis-[47.5%] flex flex-col gap-3 items-center justify-center border px-5 py-4 rounded-lg shadow-xl cursor-pointer'>
                                <img loading="lazy" src={value?.image} className='w-28 h-28' alt={value?.title} />
                                <div className='font-semibold text-primary'>{value?.title}</div>
                            </div>
                        ))}
                    </main>
                </article>
            </section>

            <section className='px-5 py-5'>
                <article className='flex justify-between items-center bg-primary text-white'>
                    <main className='flex-1 flex items-center justify-center flex-col gap-5 max-lg:gap-2 text-center px-10 max-lg:px-4 py-4'>
                        <div className='text-3xl max-lg:text-xl'>WILL YOU BE RICH AND SUCCESSFUL IN FUTURE?</div>
                        <div>Know what’s written in your stars!</div>
                        <div
                            onClick={() => navigate('/astrologer')}
                            className='cursor-pointer bg-red-900 flex items-center gap-1.5 px-4 py-2 rounded-full hover:bg-white hover:text-black hover:shadow-xl border-2 border-red-900 transition-all duration-300 ease-in'>
                            Ask An Astrologer Now
                        </div>
                    </main>
                    <img loading="lazy"
                        src='https://astroway.diploy.in/public/frontend/astrowaycdn/astroway/web/content/images/ads/success-future.png'
                        className='pr-10 py-4 h-72 max-lg:h-60 max-md:h-52'
                        alt='Success Future'
                    />
                </article>
            </section>
        </>
    );
};

export default Horoscope;
